import { isEmpty } from 'lodash';
import {
  createValidation,
  validatorRequired,
  validatorDateGreaterThen,
} from '../../utils/formValidators';
import { FORMAT_DEFAULT } from '../../utils';
import dayjs from '../../utils/dayjs';
import { tRegister as t } from '../../i18n';

import { formRegisterRepresentativeCompanyFields } from '../../constants/formRegister';

const mandateLengthValidator = (value, form) => {
  const startDate = form.get(
    formRegisterRepresentativeCompanyFields.MANDATE_DATE_START
  );

  if (isEmpty(value)) {
    return undefined;
  }

  const start = dayjs(startDate, FORMAT_DEFAULT, true);
  const end = dayjs(value, FORMAT_DEFAULT, true);

  if (!start.isValid() || !end.isValid()) return undefined;

  return end.diff(start, 'day') < 3
    ? t('representation.companyMandateLengthError')
    : undefined;
};

export default createValidation([
  {
    name: formRegisterRepresentativeCompanyFields.LEGAL_ENTITY_ID,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: formRegisterRepresentativeCompanyFields.MANDATE_DATE_START,
    validators: (field) => validatorRequired()(field),
  },
  {
    name: formRegisterRepresentativeCompanyFields.MANDATE_DATE_END,
    validators: [
      (field) => validatorDateGreaterThen()(field),
      (value, form) => mandateLengthValidator(value, form),
    ],
  },
]);
